import {useEffect} from 'react'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const usePostPaymentCollect = (
	managerId,
	numberRef,
	voucherTypeRef,
	closeEvent
) => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	const paymentTicket = () => {
		if (
			!managerId ||
			!numberRef?.current?.value ||
			voucherTypeRef?.current?.value === 'all'
		) {
			setAlert('필수 정보를 입력해주세요.')
			return
		}

		let url = `/${rolePath}/store_ticket/transfer`

		fetchRequest('POST', url, {
			type: 'ISSUE',
			count: Number(numberRef.current.value),
			storeManagerId: managerId,
			ticketTypeIdx: voucherTypeRef?.current?.value,
		})
	}

	const collectTicket = () => {
		if (
			!managerId ||
			!numberRef?.current?.value ||
			voucherTypeRef?.current?.value === 'all'
		) {
			setAlert('필수 정보를 입력해주세요.')
			return
		}

		let url = `/${rolePath}/store_ticket/transfer`

		fetchRequest('POST', url, {
			type: 'REVOKE',
			count: Number(numberRef.current.value),
			storeManagerId: managerId,
			ticketTypeIdx: voucherTypeRef?.current?.value,
		})
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				closeEvent()
				break
			default:
				if (
					fetchResult?.data?.statusCode !== 200 &&
					fetchResult?.data?.message
				) {
					setAlert(fetchResult?.data?.message)
				}
				break
		}
	}, [fetchResult])

	return [paymentTicket, collectTicket]
}

export default usePostPaymentCollect
